import React from 'react';
import { connect } from 'react-redux';
import moment from "moment";

import './style.css';
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import WorkReportTemplate from './WorkReportTemplate';
import monthlyReportService from '../../services/WorkReport/monthly-report-service';
import {
	increaseMonthlyReportLoadCounter,
	fetchMonthlyReportList,
	setMonthlyReportFilter,
	updateMonthlyReport,
	submitMonthlyReport
} from '../../actions/work-report-actions';
import {
	Table,
	Button,
	Modal,
	Spin,
	message,
	Row,
	Col,
	Icon,
	Radio,
	DatePicker
} from 'antd';
import logoImg from '../../assets/images/CJL-logo.png';

const webConfig = require('../../config.json');

class MonthlyReport extends React.Component {

	rowSelection = {
		onChange: (selectedRowKeys, selectedRows) => {
			let ids = selectedRows.map(row => row.id);
			this.setState({ selectedIDs: ids });
		},
		getCheckboxProps: record => ({
			disabled: record.status !== 0
		}),
	}
	state = {
		loading: false,
		submitLoading: false
	}

	componentWillMount() {
		if ("loaded" !== this.props.workReport.monthlyReportStatus) {
			this.props.increaseMonthlyReportLoadCounter();
		}
		if (this.props.routing.location.pathname.split('/')[3]) {
			this.setState({
				openDetail: false,
				currentModalStatus: true
			});
			monthlyReportService.initMonthlyReport({ type_id: 3 }, res => {
				this.setState({
					monthlyReportTemplate: JSON.parse(res.data.template),
					real_name: res.data.employee.real_name,
					department_name: res.data.employee.department_name,
					position_name: res.data.employee.position_name,
					district: res.data.district,
					type_id: res.data.type_id,
					report_id: null
				});
			});
		}
	}
	componentWillReceiveProps(nextProps) {
		if (nextProps.workReport.monthlyReportLoadCounter !== this.props.workReport.monthlyReportLoadCounter) {
			let gets = { type_id: 3 };
			Object.keys(nextProps.workReport.monthlyReportFilters).forEach(key => {
				if (nextProps.workReport.monthlyReportFilters[key]) {
					gets[key] = nextProps.workReport.monthlyReportFilters[key];
				}
			});
			this.props.fetchMonthlyReportList(gets);
		}
	}

	setStartDateFilter = (value, date) => {
		this.props.setMonthlyReportFilter({ start_date: date, page: 1 });
	}

	setEndDateFilter = (value, date) => {
		this.props.setMonthlyReportFilter({ end_date: date, page: 1 });
	}
	setStartDate = (val) => {
		// console.log(val);
		if (val) {
			val = val.format("YYYY-MM-DD")
		}
		this.setState({ date_1: val });
		// console.log(this.state.date_1);
	}
	setEndDate = (val) => {
		// console.log(val);
		if (val) {
			val = val.format("YYYY-MM-DD")
		}
		this.setState({ date_2: val });
		// console.log(this.state.date_1);
	}
	setStatusFilter = event => {
		this.props.setMonthlyReportFilter({ status: event.target.value, page: 1 });
	}

	setPageFilter = pagination => {
		this.props.setMonthlyReportFilter({ page: pagination.current });
	}

	newMonthlyReport = () => {
		this.setState({
			openDetail: false,
			currentModalStatus: true
		});
		monthlyReportService.initMonthlyReport({ type_id: 3 }, res => {
			this.setState({
				monthlyReportTemplate: JSON.parse(res.data.template),
				real_name: res.data.employee.real_name,
				department_name: res.data.employee.department_name,
				position_name: res.data.employee.position_name,
				district: res.data.district,
				type_id: res.data.type_id,
				report_id: null,
				date_1: null,
				date_2: null
			});
		});
	}

	saveCurrentReport = status => {
		if (!this.state.date_1) {
			message.error("请选择开始日期", 4);
			return false;
		}
		if (!this.state.date_2) {
			message.error("请选择结束日期", 4);
			return false;
		}

		let posts = {
			status: status,
			table_content: JSON.stringify(this.state.monthlyReportTemplate),
			type_id: this.state.type_id,
			date_1: this.state.date_1,
			date_2: this.state.date_2
		}
		if (!posts.table_content) {
			message.error("报告内容不能为空", 4);
			return;
		}
		if (status === 1) {
			this.setState({ submitLoading: true })
		} else {
			this.setState({ loading: true })
		}
		if (this.state.report_id) {
			posts = {
				...this.props.workReport.monthlyReportData.Data[this.state.currentIndex],
				...posts
			}
			this.props.updateMonthlyReport(posts, this.state.currentIndex, result => {
				this.setState({ loading: false, submitLoading: false })
				if (result) {
					this.closeCurrentModal();
					message.success("保存报告成功", 4);
				} else {
					message.error("保存报告失败", 4);
				}
			});
		} else {
			monthlyReportService.saveMonthlyReport(posts, res => {
				this.setState({ loading: false, submitLoading: false })
				if (res.data.Success) {
					this.closeCurrentModal();
					this.props.increaseMonthlyReportLoadCounter();
					message.success("保存报告成功", 4);
				} else {
					message.error("保存报告失败" + res.data.Errors[0], 4);
				}
			});
		}
	}

	submitCurrentReport = status => {
		Modal.confirm({
			title: '确定提交报告?报告一旦提交,将无法再修改.',
			okText: '确认',
			cancelText: '取消',
			onOk: () => this.saveCurrentReport(status),
			onCancel: () => { }
		});
	}

	editReportContent = reportContent => {
		this.setState({ monthlyReportTemplate: reportContent });
	}

	closeCurrentModal = () => {
		this.setState({ currentModalStatus: false });
	}

	updateMonthlyReport = (record, index, unedit) => {
		this.setState({
			openDetail: unedit,
			currentIndex: index,
			currentModalStatus: true
		});
		monthlyReportService.fetchMonthlyReportDetail({ modelId: record.id }, res => {
			this.setState({
				monthlyReportTemplate: JSON.parse(res.data.work_report.table_content),
				real_name: res.data.employee.real_name,
				department_name: res.data.employee.department_name,
				position_name: res.data.employee.position_name,
				district: res.data.district,
				type_id: res.data.work_report.type_id,
				next_id: res.data.next_id,
				prev_id: res.data.prev_id,
				replies: res.data.replies,
				report_id: res.data.work_report.id,
				date_1: res.data.work_report.date_1,
				date_2: res.data.work_report.date_2
			});
		});
	}

	submitReport = (record, index) => {
		Modal.confirm({
			title: '确定提交报告?报告一旦提交,将无法再修改.',
			okText: '确认',
			cancelText: '取消',
			onOk: () => {
				let puts = {
					...record,
					status: 1
				}
				this.props.submitMonthlyReport(puts, index, result => {
					if (result) {
						message.success("提交报告成功", 4);
					} else {
						message.error("提交报告失败", 4);
					}
				});
			},
			onCancel: () => { }
		});
	}

	multiDeleteMonthlyReport = () => {
		if (!this.state.selectedIDs || 0 === this.state.selectedIDs.length) {
			message.error('请选择要删除的报告', 4);
			return false;
		}
		Modal.confirm({
			title: '确定删除选中的内容么?',
			okText: '确认',
			cancelText: '取消',
			onOk: () => {
				monthlyReportService.multiDeleteMonthlyReport({ ids: this.state.selectedIDs }, res => {
					if (res.data.Success) {
						message.success('删除报告成功', 4);
						this.props.increaseMonthlyReportLoadCounter();
					} else {
						message.error('删除报告失败' + res.data.Errors, 4);
					}
				});
			},
			onCancel: () => { }
		});
	}

	render() {
		const reportColumn = [{
			title: <div><div>报告时间</div><div>Report Time</div></div>,
			dataIndex: 'created_time_str',
			key: 'created_time',
		}, {
			title: <div><div>回复时间</div><div>Reply Time</div></div>,
			dataIndex: 'reply_time_str',
			key: 'reply_time',
		}, {
			title: <div><div>状态</div><div>Status</div></div>,
			dataIndex: 'status_name',
			key: 'status_name',
		}, {
			title: <div><div>操作</div><div>Action</div></div>,
			dataIndex: 'action',
			key: 'action',
			className: "daily-report-action",
			render: (text, record, index) => (
				<span>
					{record.status === 0 ?
						<span>
							{(this.props.access.myMonthlyReport.u_value || this.props.access.employeeMyMonthlyReport.u_value) &&
								<Button icon="edit" size="small" className="row-action-btn"
									onClick={this.updateMonthlyReport.bind(this, record, index, false)}>编辑 Edit</Button>
							}
							{/*{(this.props.access.myMonthlyReport.submit_value || this.props.access.employeeMyMonthlyReport.u_value) &&*/}
							{/*	<Button icon="save" size="small" className="row-action-btn"*/}
							{/*		onClick={this.submitReport.bind(this, record, index)}>提交 Submit</Button>*/}
							{/*}*/}
						</span>
						:
						<span>
							{(this.props.access.myMonthlyReport.detail_value || this.props.access.employeeMyMonthlyReport.u_value) && <Button icon="info-circle-o" size="small" className="row-action-btn"
								onClick={this.updateMonthlyReport.bind(this, record, index, true)}>详情 View</Button>}
						</span>}
				</span>
			)
		}];
		return (
			<div className="app-module-item">
				<Modal width="1000px"
					keyboard={false}
					visible={this.state.currentModalStatus}
					title="&nbsp;"
					maskClosable={false}
					destroyOnClose={true}
					onCancel={this.closeCurrentModal}
					footer={[
						(this.props.access.myMonthlyReport.save_value || this.props.access.employeeMyMonthlyReport.u_value) && this.state.openDetail ? null : <Button key="保存" type="primary"
							onClick={this.saveCurrentReport.bind(this, 0)} disabled={this.state.loading} loading={this.state.loading}>保存 Save</Button>,
						(this.props.access.myMonthlyReport.submit_value || this.props.access.employeeMyMonthlyReport.u_value) && this.state.openDetail ? null : <Button key="提交" type="primary"
							onClick={this.submitCurrentReport.bind(this, 1)} disabled={this.state.submitLoading} loading={this.state.submitLoading}>提交 Submit</Button>,
						// <Button key="关闭" onClick={this.closeCurrentModal}>关闭 Close</Button>,
					]}>
					<div style={{ textAlign: "center", margin: "0px 0px 5px", height: "700px", overflowY: "auto", padding: "0px 15px" }}>
						<Row style={{}}>
							<Col span={18} style={{ fontSize: "32px", height: "95px", lineHeight: "40px", textAlign: "left" }}>
								<span style={{ fontWeight: "bold" }}>Monthly Work Report</span><br />
								<span style={{ fontSize: "20px", fontWeight: "bold", paddingLeft: "5px" }}>月工作报告</span>
							</Col>
							<Col span={6} style={{ fontSize: "16px", height: "30px", lineHeight: "30px", textAlign: "right" }}>
								<span style={{}}>{this.state.district}</span>
							</Col>
						</Row>
						<Row style={{ fontSize: "16px", paddingTop: "15px" }}>
							<Col span={12} style={{ height: "40px", lineHeight: "40px", textAlign: "left" }}>
								<span style={{ fontWeight: "bold" }}>Name 姓名 : </span>
								<span style={{ fontSize: "14px", paddingLeft: "15px" }}>{this.state.real_name}</span>
							</Col>
							<Col span={12} style={{ height: "40px", lineHeight: "40px", textAlign: "left" }}>
								<span style={{ fontWeight: "bold" }}>Date 日期 : </span>
								<DatePicker style={{ width: "120px" }} onChange={this.setStartDate}
									value={this.state.date_1 ? moment(this.state.date_1, "YYYY-MM-DD") : null} /> - <DatePicker style={{ width: "120px" }} onChange={this.setEndDate}
										value={this.state.date_2 ? moment(this.state.date_2, "YYYY-MM-DD") : null} />
							</Col>
						</Row>
						<Row style={{ fontSize: "16px", paddingBottom: "15px" }}>
							<Col span={12} style={{ height: "40px", lineHeight: "40px", textAlign: "left" }}>
								<span style={{ fontWeight: "bold" }}>Department 部门 : </span>
								<span style={{ fontSize: "14px", paddingLeft: "15px" }}>{this.state.department_name}</span>
							</Col>
							<Col span={12} style={{ height: "40px", lineHeight: "40px", textAlign: "left" }}>
								<span style={{ fontWeight: "bold" }}>Position 岗位 : </span>
								<span style={{ fontSize: "14px", paddingLeft: "15px" }}>{this.state.position_name}</span>
							</Col>
						</Row>
						<WorkReportTemplate currentData={this.state.monthlyReportTemplate}
							editReportContent={this.editReportContent}
							openDetail={this.state.openDetail} />
						{this.state.openDetail &&
							<div style={{ textAlign: "left", lineHeight: "30px", margin: "15px 0px" }}>
								<p>报告回复列表 : </p>
								{this.state.replies && this.state.replies.map(reply => {
									return (<div key={reply.id}>
										<span style={{ color: "blue" }}>{reply.real_name}</span>
										<span> ( </span>
										<span style={{ color: "blue" }}>
											{reply.reply_time ? moment(reply.reply_time).format("YYYY-MM-DD HH:MM") : ""}
										</span>
										<span> ) </span>
										<span> 回复 : </span>
										<span>{reply.content}</span>
									</div>)
								})}
							</div>}
						<hr style={{ height: "1px", border: "none", borderTop: "3px solid #555555" }} />
						<div>
							<img src={logoImg} alt="logo" style={{ float: "left", width: "110px", height: "auto" }} />
							<div style={{ float: "right", fontSize: "12px", height: "18px", lineHeight: "16px", textAlign: "left" }}><span>Tel: 400 6666 321</span><br /><span>www.egiraffe.com.cn</span><br /><span>GSH.20171101</span></div>
						</div>
					</div>
				</Modal>
				<div style={{ marginBottom: "20px" }}>
					{(this.props.access.myMonthlyReport.c_value || this.props.access.employeeMyMonthlyReport.c_value) &&
						<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
							<Button type="primary" onClick={this.newMonthlyReport}>
								<Icon type="plus-circle-o" />
								<span>新增 New</span>
							</Button>
						</div>
					}
					{(this.props.access.myMonthlyReport.d_value || this.props.access.employeeMyMonthlyReport.d_value) &&
						<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
							<Button type="primary" onClick={this.multiDeleteMonthlyReport}>
								<Icon type="delete" />
								<span>批量删除 Batch Delete</span>
							</Button>
						</div>
					}
					<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
						<span style={{ marginRight: "5px" }}>开始时间 Start Time: </span>
						<DatePicker onChange={this.setStartDateFilter}
							value={this.props.workReport.monthlyReportFilters.start_date ?
								moment(this.props.workReport.monthlyReportFilters.start_date, "YYYY-MM-DD") :
								null} />
					</div>
					<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
						<span style={{ marginRight: "5px" }}>结束时间 End Time: </span>
						<DatePicker onChange={this.setEndDateFilter}
							value={this.props.workReport.monthlyReportFilters.end_date ?
								moment(this.props.workReport.monthlyReportFilters.end_date, "YYYY-MM-DD") :
								null} />
					</div>
					<div className="colAction" style={{ float: "right", margin: "0px 10px 10px 0px" }}>
						<Radio.Group defaultValue={this.props.workReport.monthlyReportFilters.status}
							onChange={this.setStatusFilter}>
							<Radio.Button value={false}>全部 All</Radio.Button>
							<Radio.Button value="0">未提交 Unsubmit</Radio.Button>
							<Radio.Button value="1">未回复 Unreply</Radio.Button>
							<Radio.Button value="2">已回复 Replied</Radio.Button>
						</Radio.Group>
					</div>
					<div style={{ clear: "both" }}></div>
				</div>
				{"loaded" === this.props.workReport.monthlyReportStatus && <Table columns={reportColumn} dataSource={this.props.workReport.monthlyReportData.Data}
					rowKey={record => record.id} rowSelection={this.rowSelection}
					pagination={{
						total: this.props.workReport.monthlyReportData.Total,
						pageSize: this.props.workReport.monthlyReportData.PageSize,
						current: this.props.workReport.monthlyReportFilters.page
					}}
					onChange={this.setPageFilter} />}
				{"unload" === this.props.workReport.monthlyReportStatus && <div style={{ textAlign: 'center', margin: '100px 0px' }}><Spin size="large" /></div>}
				{"error" === this.props.workReport.monthlyReportStatus && <div style={{ textAlign: 'center', margin: '100px 0px' }}>{webConfig.httpFetchErrorInformation}</div>}
			</div>
		)
	}
}
const mapStateToProps = state => {
	return {
		workReport: state.workReport,
		routing: state.routing
	}
}
const mapDispatchToProps = {
	increaseMonthlyReportLoadCounter,
	fetchMonthlyReportList,
	setMonthlyReportFilter,
	updateMonthlyReport,
	submitMonthlyReport
}
export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(MonthlyReport));





// WEBPACK FOOTER //
// ./src/routes/WorkReport/MonthlyReport.js